// 食谱
export default [
  {
    path: '/recipes/adminDaily',
    name: 'PageAdminDialy',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/recipes/PageAdminDialy'
      ),
    meta: { modular: 70, title: '每日食谱', info: '每日食谱——首页' }
  },
  {
    path: '/recipes/commonDishesClassify',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/recipes/PageCommonDishesClassify'
      ),
    name: 'PageCommonDishesClassify',
    meta: { modular: 70, title: '常见菜设置', info: '每日食谱——常见菜设置' }
  },
  {
    path: '/recipes/commonDishes',
    name: 'PageCommonDishes',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/recipes/PageCommonDishes'
      ),
    meta: { modular: 70, title: '常见菜设置', info: '每日食谱——常见菜设置' }
  },
  {
    path: '/recipes/setting',
    name: 'PageSetting',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/recipes/PageSetting'),
    meta: { modular: 70, title: '设置', info: '每日食谱——设置' }
  },
  {
    path: '/recipes/segment',
    name: 'PageDailySegment',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/recipes/PageDailySegment'
      ),
    meta: { modular: 70, title: '就餐时段', info: '每日食谱——就餐时段' }
  },
  {
    path: '/recipes/dishes',
    name: 'PageDishes',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/recipes/PageDishes'),
    meta: { modular: 70, title: '常见菜设置', info: '每日食谱——常见菜设置' }
  }
]
